import React from "react";
import styled from "styled-components";

import { HSpace, PillButton } from "@examspark/common-ui/server";
import { Objective, ObjectivesItem, Replace } from "@examspark/types";

const StyledContainer = styled(HSpace)`
  align-items: center;
  gap: 0.5rem;
`;

const StyledLabel = styled.div`
  font-family: input-mono;
  font-size: 1.1rem;
  text-align: left;
  flex-grow: 1;
`;
const StyledLeading = styled.div``;
const StyledTrailing = styled.div`
  text-align: right;
`;

const ObjectiveBadge = (props: {
  objective?: Pick<Objective, "content" | "abbreviation"> | null;
  objectivesItem?: Replace<
    Pick<ObjectivesItem, "data" | "objective">,
    {
      objective?: Pick<Objective, "content" | "abbreviation"> | null;
    }
  > | null;
  showTooltip?: boolean;
  onClick?: () => void;
  leadingContent?: React.ReactNode;
  trailingContent?: React.ReactNode;
}) => {
  const objective = props.objective ?? props.objectivesItem?.objective;

  return (
    <PillButton onClick={props.onClick}>
      <StyledContainer>
        {!!props.leadingContent && (
          <StyledLeading>{props.leadingContent}</StyledLeading>
        )}
        <StyledLabel>{objective?.abbreviation}</StyledLabel>
        {!!props.trailingContent && (
          <StyledTrailing>{props.trailingContent}</StyledTrailing>
        )}
      </StyledContainer>
    </PillButton>
  );
};

export default ObjectiveBadge;
